import api from '@/services/api'
import { API_ENDPOINTS } from '@myorg/type-lib'

// 實作 API 介面
export const revenueApiImpl = {
  getWeeklyReport: async () => {
    // 對應 Go 後端：authorized.GET("/reports/weekly", handler.GetWeeklyReport)
    const res = await api().get(API_ENDPOINTS.REPORT.WEEKLY_REPORT)
    return res.data
  }
}

// export const revenueReportRoute: RouteRecordRaw = {
//   path: '/admin/reports/weekly',
//   name: 'WeeklyRevenueReport',
//   component: RevenueReportPage,
//   props: {
//     revenueApi: revenueApiImpl
//   }
// }